import { getModifier } from '@patternfly/react-styles';

export var GutterSize = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};

export function getGutterModifier(styleObj, size, defaultValue) {
  return getModifier(styleObj, 'gutter-' + size, defaultValue);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/styles/gutters.js
// module id = 18
// module chunks = 0